import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../layouts/Layout';
import { CustomerKategori } from '../componen/CustomerKategori';

export const CustomerCategoriPages = () => {
    const navigate = useNavigate();
    const { isError } = useSelector((state) => state.auth);

    useEffect(() => {
        if (isError) navigate('/', { replace: true });
    }, [isError, navigate]);

    return (
        <Layout>
            <CustomerKategori />
        </Layout>
    );
};